module.exports = __webpack_public_path__ + "img/1454856656.8363aa2e.jpg";